module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "excerpt"
    }
  }, [_c('h2', [_vm._v("This one time, Seona’s heart commanded.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Just this one time to be with him. This one time to love him, fully and completely. This one time to grasp a life’s worth of happiness."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Love me, Griffydd,” she pleaded fervently. “Love me now. Tonight.”"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“We will be married,” he promised as he reached out for her."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("She smiled at this honorable man who would not take what she was offering without some kind of promise between them."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“I will always be yours,” she replied softly, and truthfully, hoping it would be enough."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It had to be, for there was no more she could say."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“I love you with all my heart, wife-to-be,” he murmured, pressing feather-light kisses upon her forehead and cheeks. “I am yours forever.”"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Shh,” she hushed, afraid that if he called her “wife” again she would start to weep. “Later. We will speak of these things later.”"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Even though she knew full well that there could be no later for them."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("All they would ever have was this one time.")])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48786b22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003-excerpt.vue
// module id = 60
// module chunks = 0